import preloadChunks from '@/routes/preloadChunks.util';

const toolsRoutes = [
  {
    path: 'tools',
    children: [
      {
        index: true,
        lazy: async () => ({
          Component: (await preloadChunks['tools.main']()).default,
        }),
      },
      {
        path: 'pdf-merge',
        lazy: async () => ({
          Component: (await preloadChunks['tools.merge']()).default,
        }),
      },
      {
        path: 'pdfa-conversion',
        lazy: async () => ({
          Component: (await preloadChunks['tools.pdfa']()).default,
        }),
      },
      {
        path: 'docx-conversion',
        lazy: async () => ({
          Component: (await preloadChunks['tools.docx']()).default,
        }),
      },
      {
        path: 'redact',
        lazy: async () => ({
          Component: (await preloadChunks['tools.redact']()).default,
        }),
      },
    ],
  },
];

export default toolsRoutes;
